export default "__VITE_ASSET__1951b525__"